<template>
  <div>
    <div class="iconp">
      <img :src="photo" class="photoUrlImg" @click="showSel = true" alt="" />
    </div>

    <div class="ownMask selMask" v-show="showSel">
      <div class="selBox">
        <div class="demoMain">
          <van-icon name="cross" class="closeIcon" @click="showSel = false" />
          <h3>人像照片要求</h3>
          <div class="creDemo">
            <img :src="p11" alt="" />
            <b>正确案例</b>
            <p class="demotip">*请确保正脸出现在取景框中，以便识别</p>
          </div>
          <div class="demoBox">
            <div class="demoItem">
              <img :src="p22" alt="" />
              <p class="demotip">侧面照不可</p>
            </div>
            <div class="demoItem">
              <img :src="p33" alt="" />
              <p class="demotip">图像模糊</p>
            </div>
            <div class="demoItem">
              <img :src="p44" alt="" />
              <p class="demotip">背景复杂</p>
            </div>
            <div class="demoItem">
              <img :src="p55" alt="" />
              <p class="demotip">光线充足</p>
            </div>
          </div>
          <input
            id="uploadInput"
            type="file"
            @change="upload"
            accept="image/png, image/jpeg, image/jpg"
            style="display: none"
          />
          <label
            for="uploadInput"
            class="van-button van-button--primary van-button--normal takeBtn"
            :style="btnstyle"
            >开始拍照</label
          >
        </div>
      </div>
    </div>
    <div class="ownMask" v-show="options.img">
      <div class="ownMaskCon">
        <!-- 已上传图片 -->
        <div class="avatar-box" v-show="options.img">
          <div class="avatar-container">
            <vueCropper
              class="crop-box"
              ref="cropper"
              :img="options.img"
              :autoCrop="options.autoCrop"
              :fixedBox="options.fixedBox"
              :canMoveBox="options.canMoveBox"
              :centerBox="options.centerBox"
              :fixed="options.fixed"
              :fixedNumber="options.fixedNumber"
              :canMove="options.canMove"
              :canScale="options.canScale"
              @realTime="realTime"
            ></vueCropper>
          </div>
          <!--预览效果图-->
          <!-- <div class="show-preview">
            <div class="preview" :style="previews.div">
              <img :src="previews.url" :style="previews.img" />
            </div>
          </div> -->
          <!-- 预览效果图end -->
        </div>
        <!--底部操作工具按钮-->
        <div class="footer-btn">
          <div class="scope-btn">
            <label class="btn" for="uploads">选择图片</label>
            <input
              type="file"
              id="uploads"
              style="position: absolute; clip: rect(0 0 0 0)"
              accept="image/png, image/jpeg, image/gif, image/jpg"
              @change="upload($event)"
            />
            <!-- <button
              size="mini"
              type="danger"
              plain
              icon="el-icon-zoom-in"
              @click="changeScale(1)"
            >
              放大
            </button>
            <button
              size="mini"
              type="danger"
              plain
              icon="el-icon-zoom-out"
              @click="changeScale(-1)"
            >
              缩小
            </button> -->
            <button size="mini" type="danger" plain @click="rotateLeft">
              左转
            </button>
            <button size="mini" type="danger" plain @click="rotateRight">
              右转
            </button>
          </div>
          <div class="upload-btn">
            <button size="mini" type="success" @click="closeDialog">
              取消
            </button>
            <button
              size="mini"
              type="success"
              @click.stop.prevent="uploadImg('blob')"
            >
              确定
            </button>
          </div>
        </div>
        <!-- 底部操作工具按钮end -->
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive, defineComponent, computed } from 'vue'
import { VueCropper } from 'vue-cropper'
import 'vue-cropper/dist/index.css'
import localPhoto from '@/assets/photo.png'
import p1 from '@/assets/p1.png'
import p2 from '@/assets/p2.png'
import p3 from '@/assets/p3.png'
import p4 from '@/assets/p4.png'
import p5 from '@/assets/p5.png'
import api from '@/api/index.js'
import { useStore } from 'vuex'
export default defineComponent({
  props: {
    dialogVisible: {
      type: Boolean
    }
  },
  components: {
    VueCropper
  },
  emits: ['sendPhoto'], //添加这一行解决
  setup(props, { emit }) {
    const store = useStore()
    const mainColor = computed(() => store.state.mainColor)
    const btnstyle = reactive({
      background: mainColor.value
    })
    const showSel = ref(false)
    // console.log(11111);
    const cropper = ref()
    const uploadBtn = ref()
    const elUpload = ref()
    const options = reactive({
      img: '', // 原图文件
      autoCrop: true, // 默认生成截图框
      preview: '.previewImg', // 预览视图
      fixedBox: false, // 固定截图框大小
      canMoveBox: true, // 截图框可以拖动
      fixed: true, // 截图框宽高固定比例
      fixedNumber: [3, 4], // 截图框的宽高比例
      centerBox: true, // 截图框被限制在图片里面
      canMove: false, // 上传图片不允许拖动
      canScale: false // 上传图片不允许滚轮缩放
    })
    // vueCropper组件 裁剪配置信息

    // 读取原图
    const upload = (e) => {
      // console.log(file);
      const file = e.target.files[0]
      const isIMAGE = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isIMAGE) {
        alert('请选择 jpg、png 格式的图片')
        return false
      }
      if (!isLt5M) {
        alert('图片大小不能超过 5MB')
        return false
      }
      const reader = new FileReader()

      reader.readAsDataURL(file)

      reader.onload = (e) => {
        options.img = e.target.result // base64
      }
      // elUpload.value.clearFiles() // 这里处理重新上传时，upload组件change事件错误问题
    }
    // 获取截图信息
    const getCrop = () => {
      // 获取截图的 base64 数据
      cropper.value.getCropData((data) => {
        console.log(data)
      })
      // 获取截图的 blob 数据
      // console.log(cropper.value);
      cropper.value.getCropBlob((data) => {
        // console.log(111);
        const formData = new FormData()
        // 第三个参数是规定以什么为后缀，接口是根据后缀来返回地址格式的
        formData.append('file', data, 'chris.jpg')
        // 上传接口
        // uploadApi(formData).then((res) => {})
        closeDialog()
      })
    }
    // 重新上传
    const reupload = () => {
      uploadBtn.value.ref.click()
    }
    // 关闭弹框
    const closeDialog = () => {
      options.img = ''
    }
    // 图片缩放
    const changeScale = (num) => {
      num = num || 1
      cropper.value.changeScale(num)
    }
    // 向左旋转
    const rotateLeft = () => {
      cropper.value.rotateLeft()
    }
    // 向右旋转
    const rotateRight = () => {
      cropper.value.rotateRight()
    }
    // 实时预览函数
    const previews = ref({
      div: '',
      url: '',
      img: ''
    })
    const realTime = (data) => {
      previews.value = data
    }
    const photo = ref(localPhoto)
    const p11 = ref(p1)
    const p22 = ref(p2)
    const p33 = ref(p3)
    const p44 = ref(p4)
    const p55 = ref(p5)
    // 确定上传
    const uploadImg = (type) => {
      // const _this = this
      cropper.value.getCropData((data) => {
        photoUpload(data)
      })
      // if (type === 'blob') {
      //   // 获取截图的blob数据
      //   cropper.value.getCropBlob(async (data) => {
      //     const formData = new FormData()
      //     formData.append('file', data, 'DX.jpg')
      //     // 调用axios上传
      //   })
      // }
    }
    // 调用头像上传接口
    const photoUpload = async (img) => {
      const res = await api.uploadApi({
        base64img: img.split('base64,')[1],
        ExhCode: sessionStorage.getItem('ExhCode')
      })
      photo.value = res.data.imageUrl
      emit('sendPhoto', photo.value)
      // 清空input
      showSel.value = false
      document.querySelector('#uploadInput').value = ''
      options.img = ''
    }
    return {
      photo,
      p11,
      p22,
      p33,
      p44,
      p55,
      options,
      cropper,
      uploadBtn,
      elUpload,
      previews,
      upload,
      getCrop,
      reupload,
      closeDialog,
      changeScale,
      rotateLeft,
      rotateRight,
      realTime,
      uploadImg,
      showSel,
      btnstyle
    }
  }
})
</script>

<style lang="less" scoped>
.dialog-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  .reupload {
    color: #409eff;
    cursor: pointer;
  }
}
.photoUrlImg {
  width: 8vw;
}
.selMask {
  .demoMain {
    box-shadow: 0px 0px 10px #eee;
    width: 90vw;
    margin: 0 auto;
    padding: 5vw 3vw;
    position: relative;
    .closeIcon {
      position: absolute;
      top: 2vw;
      right: 2vw;
    }
  }
  .selBox {
    width: 100%;
    height: 100%;
    background: #fff;
    padding-top: 20vw;
    text-align: center;
    h3 {
      text-align: center;
      padding-bottom: 20px;
    }
    .creDemo {
      padding-bottom: 5vw;
      img {
        width: 30vw;
      }
      b {
        display: block;
        padding-top: 2vw;
      }
      .demotip {
        font-size: 12px;
        color: #939598;
        padding-top: 1.5vw;
      }
    }
    .demoBox {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 6vw;
      img {
        width: 16vw;
      }
      .demotip {
        font-size: 12px;
        color: #939598;
      }
    }
    .takeBtn {
      width: 80vw;
      line-height: 42px;
      margin-top: 10vw;
    }
  }
}
.ownMask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  // display: none;
  z-index: 11;
  text-align: center;
  .ownMaskCon {
    background: #fff;
    width: 98%;
    margin: 90px auto 0;
    padding: 30px;
    border-radius: 4px;
    display: inline-block;
  }
}
.avatar-box {
  display: flex;
  align-items: flex-start;
}
.avatar-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 500px;
  height: 350px;
  background-color: #f0f2f5;
  border-radius: 4px;
  .upload {
    text-align: center;
    margin-bottom: 24px;
  }
  .avatar-crop {
    width: 560px;
    height: 350px;
    position: relative;
    .crop-box {
      width: 60%;
      height: 100%;
      border-radius: 4px;
      overflow: hidden;
    }
  }
}
.show-preview {
  margin-left: 30px;
  border-left: 1px solid #ececec;
  padding-left: 30px;
  height: 100%;
  width: 200px;
  .preview {
    overflow: hidden;
    background: #eee;
    border: 1px solid #ececec;
  }
}
.footer-btn {
  // display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 30px;
  .upload-btn {
    padding-top: 10px;
  }
  button,
  label {
    display: inline-block;
    background: #409eff;
    color: #fff;
    border: 1px solid #409eff;
    border-radius: 5px;
    font-size: 14px;
    padding: 6px 10px;
    margin-right: 10px;
  }
}
@media screen and (max-width: 768px) {
  .avatar-container {
    width: 99%;
  }
  .photoUrlImg {
    width: 30vw;
  }
}
</style>
